import { render, staticRenderFns } from "./AccountingMenu.vue?vue&type=template&id=f9303842"
import script from "./AccountingMenu.vue?vue&type=script&lang=js"
export * from "./AccountingMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./AccountingMenu.vue?vue&type=custom&index=0&blockType=v-container"
if (typeof block0 === 'function') block0(component)

export default component.exports